import "./EmptyState.css";

export default function EmptyState({
  icon,
  title,
  subtitle,
  cta,
  className,
  ...rest
}) {
  const cls = ["vs-empty", className].filter(Boolean).join(" ");
  return (
    <div className={cls} {...rest}>
      {icon && (
        <div className="vs-empty__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      {title && <h3 className="vs-empty__title">{title}</h3>}
      {subtitle && <p className="vs-empty__subtitle">{subtitle}</p>}
      {cta && <div className="vs-empty__cta">{cta}</div>}
    </div>
  );
}
